RivalIQ.apps.Admin.module('models', function (models, App, Backbone, Marionette, $, _) {

    'use strict';

    models.Account = Backbone.Model.extend({
        urlRoot: '/admin/api/accounts',

        sendDashboardEmail: function (type) {
            const me = this;

            const options = {
                url: `${me.url()}/dashboardEmails/${type}`
            };

            return (me.sync || Backbone.sync).call(me, 'create', me, options);
        }
    });
});
